import type { JSX } from 'react'
import type { IAuthFormBoxProps } from '../AuthFormBox'

import { AuthFormBox } from '../AuthFormBox'
import { AuthFormBoxPaddings, AuthFormBoxRowGaps } from '../AuthFormBox.h'

export interface IAuthFormBoxPopupTemplateProps extends IAuthFormBoxProps {}

export const AuthFormBoxPopupTemplate = ({
  children,
  width = 520,
  padding = AuthFormBoxPaddings.SIZE_140,
  rowGap = AuthFormBoxRowGaps.SIZE_70,
  ...rest
}: IAuthFormBoxPopupTemplateProps): JSX.Element => (
  <AuthFormBox width={width} padding={padding} rowGap={rowGap} {...rest}>
    {children}
  </AuthFormBox>
)
